import styled from "styled-components/native";
import { SpaceType } from "@components/atoms/Spacer/types";

export const ViewContainer = styled.View<{ isGem: boolean }>`
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: ${({ isGem }) => (isGem ? 8 : 0)}px;
`;

export const FeatureButtonContainer = styled.View`
  flex-direction: row;
  gap: ${SpaceType.Double}px;
`;

export const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  max-width: 100%;
`;

export const TextContainer = styled.View`
  padding: 16px;
`;

export const SupplierContainer = styled.View<any>`
  padding-left: 3px;
  padding-right: 3px;
  padding-top: ${({ theme }) => (theme.isLargeScreen ? "24px" : "40px")};
`;

export const RefundPolicyContainer = styled.View`
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Double}px;
  padding-bottom: ${SpaceType.large + SpaceType.ExtraSmall}px;
`;
